"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPageDocumentId = isPageDocumentId;
exports.upgradePageDocument = upgradePageDocument;
const Y = __importStar(require("yjs"));
const database_document_identity_1 = require("./database-document-identity");
const page_document_maps_1 = require("./page-document-maps");
const page_document_projection_1 = require("./page-document-projection");
const page_format_chain_1 = require("./page-format-chain");
const page_read_source_1 = require("./page-read-source");
/** Whether a document holds a page: every database root does, other db$ documents do not. */
function isPageDocumentId(docId) {
    return (!docId.startsWith('db$') || (0, database_document_identity_1.extractDatabaseIdFromRootDocId)(docId) !== null);
}
/** Checks the content on a private document; refused upgrades never return writable bytes. */
function upgradePageDocument(bytes) {
    const doc = new Y.Doc();
    try {
        Y.applyUpdate(doc, bytes);
        if ((0, page_document_maps_1.readPageFormatVersion)(doc) === page_format_chain_1.PAGE_UPGRADE_STEPS.at(-1).to) {
            return { status: 'current', bytes };
        }
        // Older formats keep the whole page in one document.
        const page = (0, page_read_source_1.pageReadSource)(doc);
        const before = JSON.stringify((0, page_document_projection_1.projectPageDocument)(page));
        (0, page_format_chain_1.applyPageUpgradeSteps)(doc);
        if (JSON.stringify((0, page_document_projection_1.projectPageDocument)(page)) !== before) {
            return {
                status: 'refused',
                reason: 'Page content projection changed during upgrade',
            };
        }
        return { status: 'upgraded', bytes: Y.encodeStateAsUpdate(doc) };
    }
    catch (error) {
        return {
            status: 'refused',
            reason: error instanceof Error ? error.message : String(error),
        };
    }
    finally {
        doc.destroy();
    }
}
